import React from 'react';
import { Box, Typography, Paper, Grid, Stack, Skeleton } from '@mui/material';
import InfoToolTip from 'containers/common/components/InfoToolTip';

function SettingsSkeleton() {
  return (
    <Box>
      <Typography variant="pageTitle" mb={3}>
        Settings
        <InfoToolTip title="Manage your settings" />
      </Typography>

      <Grid container spacing={3}>
        {/* Left side - Form */}
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3 }}>
            <Box mb={3}>
              <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width={250} height={20} sx={{ mb: 2 }} />

              <Stack direction="row" spacing={2}>
                <Box sx={{ width: 120 }}>
                  <Skeleton variant="text" width={50} height={20} sx={{ mb: 1 }} />
                  <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
                </Box>
              </Stack>
            </Box>

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Skeleton variant="rectangular" width={90} height={40} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={80} height={40} sx={{ borderRadius: 1 }} />
            </Stack>
          </Paper>
        </Grid>

        {/* Right side - User Profile */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Stack spacing={2} alignItems="center">
              <Skeleton variant="circular" width={80} height={80} />
              <Skeleton variant="text" width={150} height={28} />
              <Skeleton variant="text" width={200} height={20} />
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SettingsSkeleton;
